import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';
import ptBR from './pt-BR.json';

const savedLang = localStorage.getItem('app-language') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en:    { translation: en },
    es:    { translation: es },
    'pt-BR': { translation: ptBR },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
